module.exports = {"610429001":"城关街道","610429101":"土桥镇","610429102":"职田镇","610429103":"张洪镇","610429104":"太村镇","610429105":"郑家镇","610429106":"湫坡头镇","610429107":"底庙镇","610429109":"马栏镇","610429110":"清塬镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/610429.json
// module id = 2816
// module chunks = 0